// extracted by mini-css-extract-plugin
export default {"fieldset":"KDEtVb"};